// Immediately hide None options before page fully loads
(function() {
    // Add CSS rule immediately to prevent flash
    var style = document.createElement('style');
    style.textContent = '#infiniteoptions-container input[value="None"], #infiniteoptions-container label:has(input[value="None"]) { display: none !important; }';
    document.head.appendChild(style);
})();

// Wait for DOM to be ready for additional functionality
document.addEventListener('DOMContentLoaded', function() {
    const RING_SIZE_PLACEHOLDER_TEXT = 'Select your ring size';
    
    // Enhanced function to hide None option
    function hideNoneOption() {
        // Find all None radio inputs
        const radioInputs = document.querySelectorAll('#infiniteoptions-container input[type="radio"][value="None"]');
        radioInputs.forEach(function(input) {
            // Hide the input itself
            input.style.display = 'none';
            input.style.visibility = 'hidden';
            
            // Hide the parent label
            const label = input.closest('label');
            if (label) {
                label.style.display = 'none';
                label.style.visibility = 'hidden';
                label.style.position = 'absolute';
                label.style.left = '-9999px';
            }
            
            // Also hide the parent if it's a wrapper
            const parent = input.parentElement;
            if (parent && parent.tagName === 'LABEL') {
                parent.style.display = 'none';
                parent.style.visibility = 'hidden';
            }
        });
    }

    const durabilitySettings = window.durabilityUpgradeSettings || {};
    const DURABILITY_REQUIRED_SHAPES = ['oval', 'cushion', 'emerald', 'marquise', 'moval'];
    const DURABILITY_REQUIREMENT_ERROR_MESSAGE = durabilitySettings.durabilityRequirementErrorText || 'Durability upgrade required for stones over 4ct.';
    let durabilityRequirementActive = false;
    let currentDurabilityShape = '';
    let cachedDurabilityGroup = null;
    let durabilityErrorElement = null;

    function normalizeValue(value) {
        return value ? value.toString().toLowerCase().trim() : '';
    }

    function normalizeRingSize(value) {
        return value ? value.toString().trim().toLowerCase() : '';
    }

    function getAllowedRingSizesFromPage() {
        const productInfo = document.querySelector('product-info[data-allowed-ring-sizes]');
        if (!productInfo) return [];

        const raw = productInfo.dataset.allowedRingSizes;
        if (!raw) return [];

        try {
            const parsed = JSON.parse(raw);
            if (Array.isArray(parsed)) {
                return parsed
                    .map((entry) => (entry == null ? '' : entry.toString().trim()))
                    .filter((entry) => entry !== '');
            }
        } catch (error) {
            console.warn('Unable to parse allowed ring sizes:', error);
        }

        return [];
    }

    function ringSizeOptionsMatchAllowed(selectEl, allowedNormalized) {
        const currentOptions = Array.from(selectEl.options)
            .filter((option) => option.value && normalizeRingSize(option.value) !== 'false')
            .map((option) => normalizeRingSize(option.value));

        if (currentOptions.length !== allowedNormalized.length) return false;

        for (let index = 0; index < allowedNormalized.length; index += 1) {
            if (currentOptions[index] !== allowedNormalized[index]) {
                return false;
            }
        }

        return true;
    }

    // Track if user has actively selected a ring size (not auto-selected by Infinite Options)
    let userHasSelectedRingSize = false;
    // Track if we've done the initial reset to placeholder
    let initialResetDone = false;

    function filterRingSizeOptions(preserveSelection) {
        const allowedSizes = getAllowedRingSizesFromPage();
        if (!allowedSizes.length) return;

        const container = document.querySelector('#infiniteoptions-container');
        if (!container) return;

        const select = container.querySelector('select[name="properties[Ring Size]"]');
        if (!select) return;

        const existingPlaceholderOption = Array.from(select.options).find((option) => option.value === '');
        if (existingPlaceholderOption && existingPlaceholderOption.textContent !== RING_SIZE_PLACEHOLDER_TEXT) {
            existingPlaceholderOption.textContent = RING_SIZE_PLACEHOLDER_TEXT;
        }

        const allowedNormalized = Array.from(new Set(allowedSizes.map(normalizeRingSize))).filter(Boolean);
        if (!allowedNormalized.length) return;

        // Check if options already match allowed sizes
        const optionsAlreadyMatch = ringSizeOptionsMatchAllowed(select, allowedNormalized);

        // If options already match, check if we need to reset to placeholder or can skip
        if (optionsAlreadyMatch) {
            // On initial load, reset to placeholder if not already done
            if (!preserveSelection && !initialResetDone) {
                // Just reset the value to empty without rebuilding options
                select.value = '';
                initialResetDone = true;
            }
            // Options match, no need to rebuild
            return;
        }

        // Capture current value before modifying
        const previousValue = select.value;
        const originalOptions = Array.from(select.options);

        // Rebuild the options list
        const placeholderOption = originalOptions.find((option) => option.value === '');

        select.innerHTML = '';

        // Always add placeholder first
        if (placeholderOption) {
            placeholderOption.selected = true;
            placeholderOption.textContent = RING_SIZE_PLACEHOLDER_TEXT;
            select.appendChild(placeholderOption);
        } else {
            const placeholder = document.createElement('option');
            placeholder.value = '';
            placeholder.disabled = true;
            placeholder.selected = true;
            placeholder.textContent = RING_SIZE_PLACEHOLDER_TEXT;
            select.appendChild(placeholder);
        }

        allowedNormalized.forEach((normalizedValue) => {
            const matchingOriginal = originalOptions.find(
                (option) => normalizeRingSize(option.value) === normalizedValue
            );

            const visibleValue = allowedSizes.find(
                (size) => normalizeRingSize(size) === normalizedValue
            ) || normalizedValue;

            let optionNode;
            if (matchingOriginal) {
                optionNode = matchingOriginal;
                optionNode.disabled = false;
            } else {
                optionNode = document.createElement('option');
                optionNode.value = visibleValue;
                optionNode.textContent = visibleValue;
            }

            select.appendChild(optionNode);
        });

        // Mark initial reset as done
        if (!preserveSelection) {
            initialResetDone = true;
        }

        // Only restore the previous value if:
        // 1. We're preserving selection (variant change, not initial load)
        // 2. User has actively selected a ring size
        // 3. The previous value is valid for the new allowed sizes
        if (preserveSelection && userHasSelectedRingSize && previousValue && previousValue !== '') {
            const valueToSelect = allowedSizes.find(
                (size) => normalizeRingSize(size) === normalizeRingSize(previousValue)
            );

            if (valueToSelect) {
                select.value = valueToSelect;
            }
            // If previous value not in allowed list, placeholder stays selected
        }
        // Otherwise, placeholder "Select Your Ring Size" remains selected
    }

    // Listen for user actively selecting a ring size
    function setupRingSizeSelectionTracking() {
        const container = document.querySelector('#infiniteoptions-container');
        if (!container) return;

        const select = container.querySelector('select[name="properties[Ring Size]"]');
        if (!select || select.__ringSizeTrackingSetup) return;

        select.__ringSizeTrackingSetup = true;
        select.addEventListener('change', function() {
            if (this.value && this.value !== '') {
                userHasSelectedRingSize = true;
            }
        });
    }

    function labelMatchesStone(text) {
        if (!text) return false;
        const normalized = text.toString().toLowerCase();
        if (normalized.includes('stone shape')) return true;
        if (normalized.includes('stone') && normalized.includes('shape')) return true;
        return false;
    }

    function detectedShapeMatchesRequirement(value) {
        const normalized = normalizeValue(value);
        if (!normalized) return '';
        for (let i = 0; i < DURABILITY_REQUIRED_SHAPES.length; i++) {
            const shape = DURABILITY_REQUIRED_SHAPES[i];
            const pattern = new RegExp(`(^|[^a-z0-9])${shape}([^a-z0-9]|$)`);
            if (pattern.test(normalized)) {
                return shape;
            }
        }
        return '';
    }

    function getCurrentStoneShape() {
        const productVariantSelects = document.querySelector('product-variant-selects');
        if (productVariantSelects) {
            const fieldsets = productVariantSelects.querySelectorAll('fieldset.product__variant-options');
            for (const fieldset of fieldsets) {
                const legend = fieldset.querySelector('legend.form__label, legend');
                if (legend && labelMatchesStone(legend.textContent)) {
                    const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
                    if (checkedInput && checkedInput.value) {
                        return normalizeValue(checkedInput.value);
                    }
                }
            }

            const selects = productVariantSelects.querySelectorAll('select');
            for (const select of selects) {
                const label = select.closest('.product-form__input')?.querySelector('label.form__label, label');
                if (label && labelMatchesStone(label.textContent) && select.value) {
                    return normalizeValue(select.value);
                }
            }
        }

        const checkedRadios = document.querySelectorAll('input[type="radio"]:checked');
        for (const radio of checkedRadios) {
            if (labelMatchesStone(radio.name) && radio.value) {
                return normalizeValue(radio.value);
            }
            const radioLabel = radio.closest('label');
            if (radioLabel && labelMatchesStone(radioLabel.textContent) && radio.value) {
                return normalizeValue(radio.value);
            }
        }

        const allSelects = document.querySelectorAll('select');
        for (const select of allSelects) {
            const label = select.closest('.product-form__input')?.querySelector('label.form__label, label');
            if ((labelMatchesStone(select.name) || (label && labelMatchesStone(label.textContent))) && select.value) {
                return normalizeValue(select.value);
            }
        }

        return '';
    }

    function variantMatchesRequirement(variant) {
        if (!variant) return '';
        const values = [];
        if (Array.isArray(variant.options)) {
            values.push(...variant.options);
        }
        ['option1', 'option2', 'option3', 'option4', 'option5', 'title', 'name', 'public_title'].forEach(function(key) {
            if (variant[key]) {
                values.push(variant[key]);
            }
        });
        for (let i = 0; i < values.length; i++) {
            const match = detectedShapeMatchesRequirement(values[i]);
            if (match) {
                return match;
            }
        }
        return '';
    }

    function getDurabilityContainer() {
        return document.getElementById('infiniteoptions-container') || null;
    }

    function getDurabilityGroupElement() {
        if (cachedDurabilityGroup && document.body.contains(cachedDurabilityGroup)) {
            return cachedDurabilityGroup;
        }
        const container = getDurabilityContainer();
        if (!container) return null;

        let group = container.querySelector('div[role="group"][aria-labelledby*="Durability"]');
        if (!group) {
            const possibleGroups = container.querySelectorAll('div[role="group"], fieldset, .spb-field, .spb-option, .io-choices, .infiniteoptions-options');
            for (const element of possibleGroups) {
                if (isDurabilityGroup(element)) {
                    group = element;
                    break;
                }
            }
        }

        if (group) {
            cachedDurabilityGroup = group;
            return group;
        }

        return null;
    }

    function ensureDurabilityErrorElement() {
        if (durabilityErrorElement && document.body.contains(durabilityErrorElement)) {
            return durabilityErrorElement;
        }
        const group = getDurabilityGroupElement();
        if (!group) return null;

        let error = group.parentNode ? group.parentNode.querySelector('#durability-upgrade-error') : null;
        if (!error) {
            error = document.createElement('div');
            error.id = 'durability-upgrade-error';
            error.className = 'ring-size-error durability-upgrade-error';
            error.style.display = 'none';
            error.style.fontSize = '1.3rem';
            error.style.marginTop = '6px';
            error.style.marginBottom = '20px';
            error.style.textAlign = 'left';
            error.style.padding = '12px 16px';
            error.style.boxSizing = 'border-box';
            error.setAttribute('role', 'alert');
            error.setAttribute('aria-live', 'polite');
            error.textContent = '';

            const insertAfter = group.nextElementSibling;
            if (insertAfter && insertAfter.parentNode) {
                insertAfter.parentNode.insertBefore(error, insertAfter);
            } else if (group.parentNode) {
                group.parentNode.appendChild(error);
            }
        }

        durabilityErrorElement = error;
        durabilityErrorElement.style.fontSize = '1.3rem';
        durabilityErrorElement.style.marginTop = '6px';
        durabilityErrorElement.style.marginBottom = '20px';
        durabilityErrorElement.style.textAlign = 'left';
        durabilityErrorElement.style.padding = '12px 16px';
        durabilityErrorElement.style.boxSizing = 'border-box';
        return durabilityErrorElement;
    }

    function setDurabilityGroupErrorState(isError) {
        const group = getDurabilityGroupElement();
        if (!group) return;
        group.classList.toggle('durability-upgrade-missing', !!isError);
        const radios = group.querySelectorAll('input[type="radio"]');
        radios.forEach(function(radio) {
            if (isError) {
                radio.setAttribute('aria-invalid', 'true');
            } else {
                radio.removeAttribute('aria-invalid');
            }
        });
    }

    function hideDurabilityError() {
        const error = ensureDurabilityErrorElement();
        if (error) {
            error.style.display = 'none';
        }
        setDurabilityGroupErrorState(false);
    }

    function showDurabilityError(message) {
        const error = ensureDurabilityErrorElement();
        if (!error) return;
        error.textContent = message;
        error.style.display = 'block';
        setDurabilityGroupErrorState(true);

        const group = getDurabilityGroupElement();
        if (group) {
            group.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    function isDurabilityUpgradeSelected() {
        const group = getDurabilityGroupElement();
        if (!group) return false;
        const checked = group.querySelector('input[type="radio"]:checked');
        if (!checked) return false;
        const value = normalizeValue(checked.value);
        return value && value !== 'none';
    }

    function getGroupRoot(node) {
        return node.closest('div[role="group"], fieldset, .spb-option, .spb-field, .io-choices, .infiniteoptions-options');
    }

    function isDurabilityGroup(element) {
        if (!element) return false;

        const attrStrings = [
            element.getAttribute('aria-labelledby'),
            element.getAttribute('aria-label'),
            element.id
        ];

        if (element.dataset) {
            attrStrings.push(element.dataset.name, element.dataset.title, element.dataset.optionName);
        }

        if (attrStrings.some(function(value) {
            return value && value.toLowerCase().includes('durability');
        })) {
            return true;
        }

        const headingCandidates = element.querySelectorAll('label, legend, .spb-label-tooltip, .spb-label-tooltip label, [class*="label"], [class*="title"], [class*="heading"]');
        for (let i = 0; i < headingCandidates.length; i++) {
            const text = (headingCandidates[i].textContent || '').toLowerCase();
            if (text.includes('durability')) {
                return true;
            }
        }

        const previousSibling = element.previousElementSibling;
        if (previousSibling && (previousSibling.textContent || '').toLowerCase().includes('durability')) {
            return true;
        }

        return false;
    }

    function updateDurabilityRequirementState(variant) {
        let matchedShape = variantMatchesRequirement(variant);
        if (!matchedShape) {
            const domShape = getCurrentStoneShape();
            matchedShape = detectedShapeMatchesRequirement(domShape);
        }

        durabilityRequirementActive = !!matchedShape;
        currentDurabilityShape = matchedShape;

        window.durabilityUpgradeRequirement = {
            requiresUpgrade: durabilityRequirementActive,
            stoneShape: currentDurabilityShape
        };

        if (!durabilityRequirementActive || isDurabilityUpgradeSelected()) {
            hideDurabilityError();
        }
    }

    function shouldValidateDurability(form) {
        if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return false;
        if (form.closest('.cart-drawer') || form.classList.contains('cart-drawer__form')) return false;
        if (!getDurabilityGroupElement()) return false;
        return true;
    }

    function enforceDurabilityRequirement(event) {
        if (!durabilityRequirementActive) return false;
        if (isDurabilityUpgradeSelected()) {
            hideDurabilityError();
            return false;
        }

        showDurabilityError(DURABILITY_REQUIREMENT_ERROR_MESSAGE);
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        return true;
    }
    
    // Function to handle radio button selection state
    function handleRadioSelection() {
        const container = document.querySelector('#infiniteoptions-container');
        if (!container) return;

        const radioInputs = container.querySelectorAll('input[type="radio"]');

        radioInputs.forEach(function(input) {
            // Avoid attaching duplicate listeners
            if (input.__ioListenersAttached) return;
            input.__ioListenersAttached = true;

            input.addEventListener('change', function() {
                const groupRoot = getGroupRoot(this);
                if (groupRoot) {
                    groupRoot.querySelectorAll('label').forEach(function(label) {
                        label.classList.remove('selected');
                    });
                }

                if (this.value === 'None') {
                    return;
                }

                let currentLabel = this.closest('label');
                if (!currentLabel && this.id) {
                    currentLabel = container.querySelector('label[for="' + this.id.replace(/"/g, '\\"') + '"]');
                }
                if (currentLabel && this.checked) {
                    currentLabel.classList.add('selected');
                }

                if (durabilityRequirementActive && this.value && this.value.toLowerCase() !== 'none') {
                    hideDurabilityError();
                }
            });

            if (input.value === 'None') {
                return;
            }

            let labelEl = input.closest('label');
            if (!labelEl && input.id) {
                labelEl = container.querySelector('label[for="' + input.id.replace(/"/g, '\\"') + '"]');
            }
            if (labelEl && !labelEl.__ioClickBound) {
                labelEl.__ioClickBound = true;

                const rememberState = function() {
                    input.__ioWasChecked = input.checked;
                };

                labelEl.addEventListener('pointerdown', rememberState);
                labelEl.addEventListener('mousedown', rememberState);
                labelEl.addEventListener('touchstart', rememberState, { passive: true });

                labelEl.addEventListener('click', function(e) {
                    const groupRoot = getGroupRoot(input);
                    const durabilityGroup = isDurabilityGroup(groupRoot);
                    const wasChecked = !!input.__ioWasChecked;
                    input.__ioWasChecked = undefined;

                    if (durabilityGroup && wasChecked) {
                        e.preventDefault();
                        e.stopPropagation();

                        const noneInput = groupRoot && groupRoot.querySelector('input[type="radio"][value="None"]');
                        if (noneInput) {
                            noneInput.checked = true;
                            noneInput.dispatchEvent(new Event('change', { bubbles: true }));
                        } else {
                            input.checked = false;
                            input.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                        return;
                    }

                    if (!input.checked) {
                        input.checked = true;
                        input.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                });
            }

            if (input.checked) {
                let initLabel = input.closest('label');
                if (!initLabel && input.id) {
                    initLabel = container.querySelector('label[for="' + input.id.replace(/"/g, '\\"') + '"]');
                }
                if (initLabel) {
                    initLabel.classList.add('selected');
                }
            }
        });
    }
    
    // Function to handle custom engraving checkbox
    function handleCustomEngraving() {
        const checkbox = document.querySelector('#infiniteoptions-container input[type="checkbox"]');
        if (!checkbox) return;
        
        // Find the text input container
        const textInputs = document.querySelectorAll('#infiniteoptions-container input[type="text"]');
        let textInputContainer = null;
        let textInput = null;
        
        textInputs.forEach(function(input) {
            if (input.id && input.id.includes('CUSTOM ENGRAVING TEXT')) {
                textInput = input;
                textInputContainer = input.closest('div');
            }
        });
        
        if (!textInputContainer) return;
        
        checkbox.addEventListener('change', function() {
            if (this.checked) {
                textInputContainer.style.display = 'block';
                textInputContainer.style.opacity = '1';
                textInputContainer.removeAttribute('disabled');
                
                if (textInput) {
                    textInput.removeAttribute('disabled');
                    textInput.setAttribute('name', 'properties[CUSTOM ENGRAVING TEXT]');
                }
                
                // Update the hidden input for custom engraving
                const hiddenInput = document.querySelector('input[type="hidden"][name="properties[Custom Engraving]"]');
                if (hiddenInput) {
                    hiddenInput.value = 'Custom Engraving (+$50)';
                }
            } else {
                textInputContainer.style.display = 'none';
                textInputContainer.style.opacity = '0';
                
                if (textInput) {
                    textInput.setAttribute('disabled', 'disabled');
                    textInput.value = '';
                }
                
                // Clear the hidden input for custom engraving
                const hiddenInput = document.querySelector('input[type="hidden"][name="properties[Custom Engraving]"]');
                if (hiddenInput) {
                    hiddenInput.value = '';
                }
            }
        });
        
        // Set initial state
        if (!checkbox.checked) {
            textInputContainer.style.display = 'none';
            textInputContainer.style.opacity = '0';
        }
    }
    
    // Run immediately (initial load - don't preserve selection, show placeholder)
    hideNoneOption();
    filterRingSizeOptions(false);
    setupRingSizeSelectionTracking();
    handleRadioSelection();
    handleCustomEngraving();
    updateDurabilityRequirementState();

    // Initialize functions with slight delay for dynamic content
    setTimeout(function() {
        hideNoneOption();
        filterRingSizeOptions(false);
        setupRingSizeSelectionTracking();
        handleRadioSelection();
        handleCustomEngraving();
        updateDurabilityRequirementState();
    }, 100);

    // Also run when Infinite Options loads (in case it loads dynamically)
    setTimeout(function() {
        hideNoneOption();
        filterRingSizeOptions(false);
        setupRingSizeSelectionTracking();
        handleRadioSelection();
        handleCustomEngraving();
        updateDurabilityRequirementState();
    }, 1000);

    // Watch for DOM changes in case Infinite Options loads later
    const observer = new MutationObserver(function(mutations) {
        // Re-apply behaviors whenever Infinite Options mutates
        hideNoneOption();
        // Always preserve selection after initial load (initialResetDone handles the first reset)
        filterRingSizeOptions(true);
        setupRingSizeSelectionTracking();
        handleRadioSelection();
        handleCustomEngraving();
        updateDurabilityRequirementState();
    });
    
    const container = document.querySelector('#infiniteoptions-container');
    if (container) {
        observer.observe(container, { 
            childList: true, 
            subtree: true,
            attributes: false // Don't watch attribute changes to avoid loops
        });
    }

    document.addEventListener('variant:change', function(event) {
        filterRingSizeOptions(true); // Preserve user's selection on variant change
        updateDurabilityRequirementState(event?.detail?.variant);
    });

    const variantChangeEventName = (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) ? PUB_SUB_EVENTS.variantChange : 'variant-change';

    if (typeof subscribe === 'function' && variantChangeEventName) {
        try {
            subscribe(variantChangeEventName, function(payload) {
                const variant = payload && payload.data ? payload.data.variant : undefined;
                filterRingSizeOptions(true); // Preserve user's selection on variant change
                updateDurabilityRequirementState(variant);
            });
        } catch (e) {
            console.warn('Durability requirement subscription failed:', e);
        }
    }

    function validateRingSizeOnSubmit(event, form) {
        const allowedSizes = getAllowedRingSizesFromPage();
        if (!allowedSizes.length) return false; // No validation needed if no metafield exists

        const container = document.querySelector('#infiniteoptions-container');
        if (!container) return false;

        const ringSizeSelect = container.querySelector('select[name="properties[Ring Size]"]');
        if (!ringSizeSelect) return false; // No ring size selector on this product

        const selectedValue = ringSizeSelect.value;

        // Check if a ring size was selected
        if (!selectedValue || selectedValue === '' || selectedValue === 'false') {
            showRingSizeError('Please select a ring size before adding to cart.');
            event.preventDefault();
            event.stopPropagation();
            return true; // Blocked
        }

        // Check if the selected ring size is in the allowed list
        const normalizedSelected = normalizeRingSize(selectedValue);
        const allowedNormalized = allowedSizes.map(normalizeRingSize);

        if (!allowedNormalized.includes(normalizedSelected)) {
            showRingSizeError('The selected ring size is not available for this product. Please select a different size.');
            event.preventDefault();
            event.stopPropagation();
            return true; // Blocked
        }

        hideRingSizeError();
        return false; // Not blocked
    }

    function showRingSizeError(message) {
        const container = document.querySelector('#infiniteoptions-container');
        if (!container) return;

        let errorElement = document.getElementById('ring-size-validation-error');
        if (!errorElement) {
            errorElement = document.createElement('div');
            errorElement.id = 'ring-size-validation-error';
            errorElement.className = 'ring-size-error';
            errorElement.style.display = 'none';
            errorElement.style.color = '#c25151';
            errorElement.style.fontSize = '1.3rem';
            errorElement.style.marginTop = '0.5rem';
            errorElement.style.marginBottom = '1rem';
            errorElement.style.padding = '12px 16px';
            errorElement.style.backgroundColor = '#fff4f4';
            errorElement.style.border = '1px solid #c25151';
            errorElement.style.borderRadius = '4px';
            errorElement.setAttribute('role', 'alert');
            errorElement.setAttribute('aria-live', 'assertive');

            // Insert after the ring size select
            const ringSizeSelect = container.querySelector('select[name="properties[Ring Size]"]');
            if (ringSizeSelect && ringSizeSelect.parentElement) {
                ringSizeSelect.parentElement.insertAdjacentElement('afterend', errorElement);
            } else {
                container.appendChild(errorElement);
            }
        }

        errorElement.textContent = message;
        errorElement.style.display = 'block';

        // Scroll to error
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });

        // Highlight the select dropdown
        const ringSizeSelect = container.querySelector('select[name="properties[Ring Size]"]');
        if (ringSizeSelect) {
            ringSizeSelect.style.borderColor = '#c25151';
            ringSizeSelect.style.boxShadow = '0 0 0 1px #c25151';
        }
    }

    function hideRingSizeError() {
        const errorElement = document.getElementById('ring-size-validation-error');
        if (errorElement) {
            errorElement.style.display = 'none';
        }

        const container = document.querySelector('#infiniteoptions-container');
        if (container) {
            const ringSizeSelect = container.querySelector('select[name="properties[Ring Size]"]');
            if (ringSizeSelect) {
                ringSizeSelect.style.borderColor = '';
                ringSizeSelect.style.boxShadow = '';
            }
        }
    }

    document.addEventListener('submit', function(event) {
        const form = event.target;

        // Validate ring size first
        if (form.action && form.action.indexOf('/cart/add') !== -1) {
            const ringSizeBlocked = validateRingSizeOnSubmit(event, form);
            if (ringSizeBlocked) return;
        }

        // Then validate durability
        if (!shouldValidateDurability(form)) return;
        updateDurabilityRequirementState();
        enforceDurabilityRequirement(event);
    }, true);

    document.addEventListener('click', function(event) {
        const button = event.target.closest('[name="add"], .btn-product-add, .product-form__submit, button[type="submit"], input[type="submit"]');
        if (!button) return;
        const form = button.closest('form[data-product-form], form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
        if (!form) return;

        // Check if this is an add to cart button (not a different submit button)
        if (form.action && form.action.indexOf('/cart/add') !== -1) {
            // Validate ring size on button click
            const ringSizeBlocked = validateRingSizeOnSubmit(event, form);
            if (ringSizeBlocked) return;
        }

        // Then validate durability
        if (!shouldValidateDurability(form)) return;
        updateDurabilityRequirementState();
        enforceDurabilityRequirement(event);
    }, true);

    document.addEventListener('change', function(event) {
        const target = event.target;
        if (!target) return;

        // Hide ring size error when user changes selection
        if (target.matches('select[name="properties[Ring Size]"]')) {
            const selectedValue = target.value;
            if (selectedValue && selectedValue !== '' && selectedValue !== 'false') {
                const allowedSizes = getAllowedRingSizesFromPage();
                const normalizedSelected = normalizeRingSize(selectedValue);
                const allowedNormalized = allowedSizes.map(normalizeRingSize);

                // Only hide error if the selection is valid
                if (allowedNormalized.includes(normalizedSelected)) {
                    hideRingSizeError();
                }
            }
        }

        if (target.matches('.product__variant-options input[type="radio"], .product__variant-options select, select[name^="options"], input[name^="options"], [data-product-option] input[type="radio"], [data-product-option] select')) {
            setTimeout(function() {
                updateDurabilityRequirementState();
            }, 50);
        }
    });
});
